import moment from "moment";

const TIME_PARSE_FORMATS = ["HH:mm:ss", "HH:mm", "h:mm A", "hh:mm A"];

/** Normalize API / DB times to HH:mm for HTML type="time" inputs. */
export function normalizeTimeForInput(
  time: string | number | null | undefined
): string {
  if (time === null || time === undefined || String(time).trim() === "") {
    return "";
  }
  const parsed = moment(String(time), TIME_PARSE_FORMATS, true);
  return parsed.isValid() ? parsed.format("HH:mm") : "";
}

const timeStringToMinutes = (time: string): number => {
  const normalized = normalizeTimeForInput(time);
  if (!normalized) return 0;
  const parsed = moment(normalized, TIME_PARSE_FORMATS, true);
  if (parsed.isValid()) {
    return parsed.hours() * 60 + parsed.minutes();
  }
  const [hours, minutes] = normalized.split(":").map(Number);
  return (hours || 0) * 60 + (minutes || 0);
};

const minutesToTimeString = (totalMinutes: number): string => {
  const normalized = ((totalMinutes % (24 * 60)) + 24 * 60) % (24 * 60);
  const hours = Math.floor(normalized / 60);
  const mins = normalized % 60;
  return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};

/** Step time up/down for HTML time inputs (arrow keys); step is in minutes. */
export function adjustTimeWithArrowKey(
  currentValue: string,
  key: "ArrowUp" | "ArrowDown",
  stepMinutes = 1,
  minTime?: string,
  maxTime?: string
): string {
  const minMinutes = minTime ? timeStringToMinutes(minTime) : 0;
  const maxMinutes = maxTime ? timeStringToMinutes(maxTime) : 24 * 60 - 1;
  const delta = key === "ArrowUp" ? stepMinutes : -stepMinutes;

  let nextMinutes = timeStringToMinutes(currentValue);
  if (!normalizeTimeForInput(currentValue)) {
    nextMinutes = minTime ? minMinutes : 0;
  } else {
    nextMinutes += delta;
  }

  if (minTime && nextMinutes < minMinutes) nextMinutes = minMinutes;
  if (maxTime && nextMinutes > maxMinutes) nextMinutes = maxMinutes;

  return minutesToTimeString(nextMinutes);
}
